import { createContext } from 'react';
import { VehicleType } from '../components/common/CommonTypes';

export type VehicleState = {
    vehicles: VehicleType[];
    selectedVehicleIndex: number;
};

export type VehicleContextState = {
    vehicles: VehicleType[];
    selectedVehicleIndex: number;
    setVehicles: (vehicles: VehicleType[]) => void;
    setSelectedVehicle: (selectedIndex: number) => void;
};

const initialState: VehicleContextState = {
    vehicles: [],
    selectedVehicleIndex: -1,
    setVehicles: undefined,
    setSelectedVehicle: undefined
};

export const VehicleContext = createContext(initialState);
